import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestSsnComponent as TestSsnComponent } from './test-ssn.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  AgreementAreaModule,
  AirportModule,
  RadiobuttonBoxModule,
  SelectDateYmdModule,
  DateSelectorModule,
  ToggleModule,
  TabModule,
  SelectModule,
  CheckboxModule,
  ValidationErrorModule,
  ButtonModule,
} from '@lib/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GetBasicReservationInformationStoreServiceModule } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.module';
import { AuthorizationServiceModule } from '@lib/services';
import { SubTestComponent } from './sub-test/sub-test.component';
import { StaticMsgModule } from '@lib/pipes';
import { TabTestComponent } from './tab-test/tab-test.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [TestSsnComponent, SubTestComponent, TabTestComponent],
  exports: [TestSsnComponent],
  imports: [
    RouterModule.forChild([{ path: '', component: TestSsnComponent }]),
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AirportModule,
    DateSelectorModule,
    AgreementAreaModule,
    SelectDateYmdModule,
    RadiobuttonBoxModule,
    ToggleModule,
    TabModule,
    SelectModule,
    CheckboxModule,
    GetBasicReservationInformationStoreServiceModule,
    StaticMsgModule,
    ValidationErrorModule,
    ButtonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TestSsnModule {}
